import React, {useContext} from 'react';
import {Pagination as DesyPagination} from '@bonprix/design-system';
import {useDispatch} from 'react-redux';
import {getContentAjaxUrl, yieldToMain} from '../ArticleOverviewHelper';
import Landmark from '@core/scripts/components/landmark-adapter';
import {Constants} from '../view-constants';
import {setContentAjaxCall} from '../AjaxCallSlice.jsx';
import {articleOverviewStaticContext} from '../ArticleOverviewStatic.jsx';

export default function Pagination({pagination, isShopContent}) {
    const dispatch = useDispatch();
    const {contentAjaxUrl, currentSearchParams, prettyUrl,shouldScrollUpAfterLoad} = useContext(articleOverviewStaticContext);

    const handleOnClick = (newPage, origin) => {
        yieldToMain(() => {
            const lmPageValue = origin === 'page' ? newPage : origin;
            const lmData = `${isShopContent ? Constants.LANDMARK_PAGETYPE_AOP : Constants.LANDMARK_PAGETYPE_SRP}_page_${lmPageValue}`;
            Landmark.sendClickLandmark(lmData);

            const currentSearchParamsCopy = new URLSearchParams(currentSearchParams.current);
            currentSearchParamsCopy.set(Constants.SEARCH_PARAMS_PAGE, newPage);
            currentSearchParams.current = currentSearchParamsCopy;

            const formattedParams = `?${currentSearchParamsCopy.toString()}`;
            const contentAjaxCall = getContentAjaxUrl(prettyUrl.current, formattedParams, contentAjaxUrl);

            // Update the browser's URL to reflect the new page parameter without reloading the page.
            // This ensures that currentPageFromUrl reads the correct page from the URL, so teaser content and pagination work as expected.
            window.history.pushState({}, '', formattedParams);

            shouldScrollUpAfterLoad.current = true;
            dispatch(setContentAjaxCall([contentAjaxCall, false, false]));
        });
    };

    const constructPageHref = (pageNumber) => {
        const url = new URL(pagination.baseHref, window.location.origin);
        if (pageNumber !== 1) url.searchParams.set("page", pageNumber.toString());
        return url.toString();
    };

    return (
        <div className="pagination__wrapper">
            <DesyPagination
                currentPage={pagination.currentPageNumber}
                totalPages={pagination.numberOfPages}
                constructPageHref={constructPageHref}
                onPageChange={handleOnClick}
            />
        </div>
    );
}
